import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ResizeObserver } from '@juggle/resize-observer';
const RESIZE_OBSERVER = new InjectionToken("Resize Observer", {
  providedIn: "root",
  factory: () => window.ResizeObserver || null
});
class NgResizeObserver extends Observable {}
let ResizeObserverService = /*#__PURE__*/(() => {
  class ResizeObserverService {
    constructor(chgRef, el, ResizeObserver) {
      this.chgRef = chgRef;
      this.el = el;
      this.ResizeObserver = ResizeObserver;
      this.onResizeSubject = new Subject();
      this.onResize = this.onResizeSubject.asObservable();
      if (this.el === null) {
        console.error(`ng-resize-observer: No provider for ElementRef. This error is most likely because you added the ng-resize-observer provider in a @NgModule. Only add ng-resize-observer on @Component()`);
        return;
      }
      if (this.ResizeObserver === null) {
        console.error(`ng-resize-observer: ResizeObserver not available. Use the ponyfill module: NgResizeObserverPonyfillModule.`);
        return;
      }
      this.observe();
    }
    ngOnDestroy() {
      this.unobserve();
      this.onResizeSubject.complete();
    }
    observe() {
      this.resizeObserver = new this.ResizeObserver(entries => {
        const entry = entries && entries[0];
        if (entry) {
          this.onResizeSubject.next(entry);
          this.chgRef.detectChanges();
        }
      });
      this.resizeObserver.observe(this.target);
    }
    unobserve() {
      this.resizeObserver.unobserve(this.target);
    }
    get target() {
      return this.el.nativeElement;
    }
    static {
      this.ɵfac = function ResizeObserverService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResizeObserverService)(i0.ɵɵinject(i0.ChangeDetectorRef), i0.ɵɵinject(i0.ElementRef, 8), i0.ɵɵinject(RESIZE_OBSERVER));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ResizeObserverService,
        factory: ResizeObserverService.ɵfac
      });
    }
  }
  return ResizeObserverService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function ngResizeObserverFactory(resizeObserverService) {
  return resizeObserverService.onResize;
}
const NgResizeObserverProvider = {
  provide: NgResizeObserver,
  useFactory: ngResizeObserverFactory,
  deps: [ResizeObserverService]
};
function ponyFillFactory() {
  return window.ResizeObserver || ResizeObserver;
}
;
const polyfillProvider = {
  provide: RESIZE_OBSERVER,
  useFactory: ponyFillFactory
};
let NgResizeObserverPonyfillModule = /*#__PURE__*/(() => {
  class NgResizeObserverPonyfillModule {
    static {
      this.ɵfac = function NgResizeObserverPonyfillModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgResizeObserverPonyfillModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NgResizeObserverPonyfillModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [polyfillProvider]
      });
    }
  }
  return NgResizeObserverPonyfillModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ngResizeObserverProviders = [NgResizeObserverProvider, ResizeObserverService];
const ngResizeObserverProvidersWithPonyfill = [...ngResizeObserverProviders, polyfillProvider];

/**
 * Generated bundle index. Do not edit.
 */

export { NgResizeObserver, NgResizeObserverPonyfillModule, ngResizeObserverProviders, ngResizeObserverProvidersWithPonyfill };
